// extracted by mini-css-extract-plugin
export default {"logo":"gkGOeX","link":"s4MLkp"};